var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c(
        "gg-card-text",
        {
          staticClass: "pa-3"
        },
        [
          _c(
            "div",
            {
              staticClass: "d-flex flex-wrap align-center mb-3"
            },
            [
              _c(
                "h2",
                {
                  staticClass: "body-1 mr-auto kvm-card-title"
                },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "pb-1",
                      attrs: {
                        size: "24",
                        color: "primary",
                        "aria-hidden": "true"
                      }
                    },
                    [_vm._v("mdi-shield-outline")]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "ml-2"
                    },
                    [_vm._v("Firewall")]
                  )
                ],
                1
              ),
              _c(
                "gg-btn",
                {
                  attrs: {
                    small: "",
                    tile: "",
                    color: "primary",
                    disabled: !_vm.capable || _vm.loadingFirst || !!_vm.error
                  },
                  on: {
                    click: _vm.openAdd
                  }
                },
                [
                  _c(
                    "v-icon",
                    {
                      attrs: {
                        left: "",
                        small: "",
                        "aria-hidden": "true"
                      }
                    },
                    [_vm._v("mdi-plus")]
                  ),
                  _vm._v("Add rule ")
                ],
                1
              )
            ],
            1
          ),
          !_vm.capable
            ? _c(
                "v-alert",
                {
                  staticClass: "mb-0",
                  attrs: {
                    type: "info",
                    border: "left",
                    dense: ""
                  }
                },
                [_vm._v(" The firewall isn't available for this server yet. ")]
              )
            : [
                _vm.loadingFirst
                  ? _c(
                      "div",
                      {
                        staticClass: "py-8 text-center",
                        attrs: {
                          role: "status",
                          "aria-live": "polite"
                        }
                      },
                      [
                        _c("v-progress-circular", {
                          attrs: {
                            indeterminate: "",
                            color: "primary",
                            size: "36",
                            width: "3"
                          }
                        }),
                        _c(
                          "span",
                          {
                            staticClass: "kvm-sr-only"
                          },
                          [_vm._v("Loading firewall…")]
                        )
                      ],
                      1
                    )
                  : _vm.error
                  ? _c(
                      "v-alert",
                      {
                        staticClass: "mb-0",
                        attrs: {
                          type: "error",
                          border: "left",
                          dense: "",
                          role: "alert"
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.error.message ||
                                "The firewall could not be loaded."
                            ) +
                            " "
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "mt-2"
                          },
                          [
                            _c(
                              "gg-btn",
                              {
                                staticClass: "error--text",
                                attrs: {
                                  small: "",
                                  tile: "",
                                  color: "white"
                                },
                                on: {
                                  click: function click($event) {
                                    return _vm.load()
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      left: "",
                                      small: "",
                                      "aria-hidden": "true"
                                    }
                                  },
                                  [_vm._v("mdi-refresh")]
                                ),
                                _vm._v("Retry ")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  : [
                      _c(
                        "div",
                        {
                          staticClass: "d-flex flex-wrap align-center"
                        },
                        [
                          _c("v-select", {
                            staticClass: "mr-3 mb-2",
                            staticStyle: {
                              "max-width": "180px"
                            },
                            attrs: {
                              items: _vm.policyOptions,
                              label: "Default inbound",
                              outlined: "",
                              dense: "",
                              "hide-details": ""
                            },
                            model: {
                              value: _vm.policyIn,
                              callback: function callback($$v) {
                                _vm.policyIn = $$v
                              },
                              expression: "policyIn"
                            }
                          }),
                          _c("v-select", {
                            staticClass: "mr-3 mb-2",
                            staticStyle: {
                              "max-width": "180px"
                            },
                            attrs: {
                              items: _vm.policyOptions,
                              label: "Default outbound",
                              outlined: "",
                              dense: "",
                              "hide-details": ""
                            },
                            model: {
                              value: _vm.policyOut,
                              callback: function callback($$v) {
                                _vm.policyOut = $$v
                              },
                              expression: "policyOut"
                            }
                          }),
                          _vm.policyDropCausing
                            ? _c("v-checkbox", {
                                staticClass: "mt-0 mr-3 mb-2",
                                attrs: {
                                  label: "Reset existing connections",
                                  dense: "",
                                  "hide-details": ""
                                },
                                model: {
                                  value: _vm.policyImmediate,
                                  callback: function callback($$v) {
                                    _vm.policyImmediate = $$v
                                  },
                                  expression: "policyImmediate"
                                }
                              })
                            : _vm._e(),
                          _c(
                            "gg-btn",
                            {
                              staticClass: "mb-2",
                              attrs: {
                                small: "",
                                tile: "",
                                color: "primary",
                                loading: _vm.savingPolicy,
                                disabled: !_vm.policyChanged
                              },
                              on: {
                                click: _vm.savePolicy
                              }
                            },
                            [_vm._v(" Save policy ")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "p",
                        {
                          staticClass: "kvm-help text-caption mt-1 mb-4"
                        },
                        [
                          _vm._v(
                            " The firewall is always on and can't be disabled. Provider security rules (e.g. the outbound SMTP block) apply regardless of these defaults. "
                          )
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "kvm-fw-table"
                        },
                        [
                          _c(
                            "v-simple-table",
                            {
                              staticClass: "vds-fw-table",
                              attrs: {
                                dense: ""
                              }
                            },
                            [
                              _c(
                                "caption",
                                {
                                  staticClass: "kvm-sr-only"
                                },
                                [_vm._v("Firewall rules")]
                              ),
                              _c("thead", [
                                _c("tr", [
                                  _c(
                                    "th",
                                    {
                                      staticStyle: {
                                        width: "60px"
                                      },
                                      attrs: {
                                        scope: "col"
                                      }
                                    },
                                    [_vm._v("On")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      attrs: {
                                        scope: "col"
                                      }
                                    },
                                    [_vm._v("Dir")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      attrs: {
                                        scope: "col"
                                      }
                                    },
                                    [_vm._v("Action")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      attrs: {
                                        scope: "col"
                                      }
                                    },
                                    [_vm._v("Proto")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      attrs: {
                                        scope: "col"
                                      }
                                    },
                                    [_vm._v("Source")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      attrs: {
                                        scope: "col"
                                      }
                                    },
                                    [_vm._v("Destination")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      attrs: {
                                        scope: "col"
                                      }
                                    },
                                    [_vm._v("Ports")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      attrs: {
                                        scope: "col"
                                      }
                                    },
                                    [_vm._v("Comment")]
                                  ),
                                  _c(
                                    "th",
                                    {
                                      staticStyle: {
                                        width: "84px"
                                      },
                                      attrs: {
                                        scope: "col"
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "kvm-sr-only"
                                        },
                                        [_vm._v("Actions")]
                                      )
                                    ]
                                  )
                                ])
                              ]),
                              _c(
                                "tbody",
                                [
                                  _vm._l(_vm.rules, function(rule) {
                                    return _c(
                                      "tr",
                                      {
                                        key: rule.pos
                                      },
                                      [
                                        _c(
                                          "td",
                                          {
                                            attrs: {
                                              "data-label": "On"
                                            }
                                          },
                                          [
                                            _c("v-switch", {
                                              staticClass:
                                                "mt-0 pt-0 kvm-fw-switch",
                                              attrs: {
                                                "input-value": rule.enable,
                                                dense: "",
                                                "hide-details": "",
                                                label: _vm.ruleSwitchLabel(
                                                  rule
                                                ),
                                                loading:
                                                  _vm.busyPos === rule.pos,
                                                disabled:
                                                  rule.system_managed ||
                                                  _vm.busyPos != null
                                              },
                                              on: {
                                                change: function change(val) {
                                                  return _vm.toggleRule(
                                                    rule,
                                                    val
                                                  )
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "td",
                                          {
                                            attrs: {
                                              "data-label": "Dir"
                                            }
                                          },
                                          [
                                            _c(
                                              "v-chip",
                                              {
                                                staticClass: "text-uppercase",
                                                attrs: {
                                                  "x-small": "",
                                                  label: ""
                                                }
                                              },
                                              [_vm._v(_vm._s(rule.type))]
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "td",
                                          {
                                            attrs: {
                                              "data-label": "Action"
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "font-weight-medium kvm-fw-action",
                                                class:
                                                  "kvm-fw-action--" +
                                                  _vm.actionClass(rule.action)
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(rule.action || "—")
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          {
                                            attrs: {
                                              "data-label": "Proto"
                                            }
                                          },
                                          [_vm._v(_vm._s(rule.proto || "any"))]
                                        ),
                                        _c(
                                          "td",
                                          {
                                            staticClass: "vds-fw-addr",
                                            attrs: {
                                              "data-label": "Source"
                                            }
                                          },
                                          [_vm._v(_vm._s(rule.source || "—"))]
                                        ),
                                        _c(
                                          "td",
                                          {
                                            staticClass: "vds-fw-addr",
                                            attrs: {
                                              "data-label": "Destination"
                                            }
                                          },
                                          [_vm._v(_vm._s(rule.dest || "—"))]
                                        ),
                                        _c(
                                          "td",
                                          {
                                            staticClass: "vds-fw-addr",
                                            attrs: {
                                              "data-label": "Ports"
                                            }
                                          },
                                          [_vm._v(_vm._s(_vm.portsLabel(rule)))]
                                        ),
                                        _c(
                                          "td",
                                          {
                                            attrs: {
                                              "data-label": "Comment"
                                            }
                                          },
                                          [
                                            rule.system_managed
                                              ? [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        "x-small": "",
                                                        "aria-hidden": "true",
                                                        title:
                                                          "Provider-managed"
                                                      }
                                                    },
                                                    [_vm._v("mdi-lock")]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "kvm-sr-only"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Provider-managed, read-only. "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : _vm._e(),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "kvm-help"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(rule.comment || "—")
                                                )
                                              ]
                                            )
                                          ],
                                          2
                                        ),
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: {
                                              "data-label": "Actions"
                                            }
                                          },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  icon: "",
                                                  small: "",
                                                  disabled: !_vm.canEdit(rule),
                                                  "aria-label":
                                                    "Edit rule: " +
                                                    _vm.ruleSummary(rule),
                                                  title: "Edit"
                                                },
                                                on: {
                                                  click: function click(
                                                    $event
                                                  ) {
                                                    return _vm.openEdit(rule)
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      "aria-hidden": "true"
                                                    }
                                                  },
                                                  [_vm._v("mdi-pencil")]
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  icon: "",
                                                  small: "",
                                                  disabled: !_vm.canDelete(
                                                    rule
                                                  ),
                                                  "aria-label":
                                                    "Delete rule: " +
                                                    _vm.ruleSummary(rule),
                                                  title: "Delete"
                                                },
                                                on: {
                                                  click: function click(
                                                    $event
                                                  ) {
                                                    return _vm.confirmDelete(
                                                      rule
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      "aria-hidden": "true"
                                                    }
                                                  },
                                                  [_vm._v("mdi-delete")]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  }),
                                  !_vm.rules.length
                                    ? _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "text-center kvm-help py-4 kvm-empty-cell",
                                            attrs: {
                                              colspan: "9"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "No rules yet. Add one to get started."
                                            )
                                          ]
                                        )
                                      ])
                                    : _vm._e()
                                ],
                                2
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
              ],
          _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "600",
                persistent: "",
                scrollable: ""
              },
              model: {
                value: _vm.ruleDialog,
                callback: function callback($$v) {
                  _vm.ruleDialog = $$v
                },
                expression: "ruleDialog"
              }
            },
            [
              _c(
                "gg-card",
                [
                  _c(
                    "gg-card-text",
                    {
                      staticClass: "pa-4"
                    },
                    [
                      _c(
                        "h2",
                        {
                          staticClass: "body-1 mb-3 kvm-card-title"
                        },
                        [_vm._v(_vm._s(_vm.editing ? "Edit rule" : "Add rule"))]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "d-flex flex-wrap"
                        },
                        [
                          _c("v-select", {
                            staticClass: "mr-3 mb-3",
                            staticStyle: {
                              "max-width": "160px"
                            },
                            attrs: {
                              items: _vm.directionOptions,
                              label: "Direction",
                              outlined: "",
                              dense: "",
                              "hide-details": ""
                            },
                            model: {
                              value: _vm.form.type,
                              callback: function callback($$v) {
                                _vm.$set(_vm.form, "type", $$v)
                              },
                              expression: "form.type"
                            }
                          }),
                          _c("v-select", {
                            staticClass: "mr-3 mb-3",
                            staticStyle: {
                              "max-width": "160px"
                            },
                            attrs: {
                              items: _vm.actionOptions,
                              label: "Action",
                              outlined: "",
                              dense: "",
                              "hide-details": ""
                            },
                            model: {
                              value: _vm.form.action,
                              callback: function callback($$v) {
                                _vm.$set(_vm.form, "action", $$v)
                              },
                              expression: "form.action"
                            }
                          }),
                          _c("v-select", {
                            staticClass: "mb-3",
                            staticStyle: {
                              "max-width": "160px"
                            },
                            attrs: {
                              items: _vm.protoOptions,
                              label: "Protocol",
                              outlined: "",
                              dense: "",
                              "hide-details": ""
                            },
                            model: {
                              value: _vm.form.proto,
                              callback: function callback($$v) {
                                _vm.$set(_vm.form, "proto", $$v)
                              },
                              expression: "form.proto"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "d-flex flex-wrap"
                        },
                        [
                          _c("v-text-field", {
                            staticClass: "mr-3 mb-3",
                            staticStyle: {
                              "max-width": "220px"
                            },
                            attrs: {
                              label: "Source",
                              placeholder: "IP / CIDR / list",
                              outlined: "",
                              dense: "",
                              "hide-details": "auto"
                            },
                            model: {
                              value: _vm.form.source,
                              callback: function callback($$v) {
                                _vm.$set(_vm.form, "source", $$v)
                              },
                              expression: "form.source"
                            }
                          }),
                          _c("v-text-field", {
                            staticClass: "mb-3",
                            staticStyle: {
                              "max-width": "220px"
                            },
                            attrs: {
                              label: "Destination",
                              placeholder: "IP / CIDR / list",
                              outlined: "",
                              dense: "",
                              "hide-details": "auto"
                            },
                            model: {
                              value: _vm.form.dest,
                              callback: function callback($$v) {
                                _vm.$set(_vm.form, "dest", $$v)
                              },
                              expression: "form.dest"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "d-flex flex-wrap"
                        },
                        [
                          _c("v-text-field", {
                            staticClass: "mr-3 mb-3",
                            staticStyle: {
                              "max-width": "220px"
                            },
                            attrs: {
                              label: "Destination port",
                              placeholder: "443, 8000:8100",
                              disabled: !_vm.portsAllowed,
                              outlined: "",
                              dense: "",
                              "hide-details": "auto"
                            },
                            model: {
                              value: _vm.form.dport,
                              callback: function callback($$v) {
                                _vm.$set(_vm.form, "dport", $$v)
                              },
                              expression: "form.dport"
                            }
                          }),
                          _c("v-text-field", {
                            staticClass: "mb-3",
                            staticStyle: {
                              "max-width": "220px"
                            },
                            attrs: {
                              label: "Source port",
                              placeholder: "optional",
                              disabled: !_vm.portsAllowed,
                              outlined: "",
                              dense: "",
                              "hide-details": "auto"
                            },
                            model: {
                              value: _vm.form.sport,
                              callback: function callback($$v) {
                                _vm.$set(_vm.form, "sport", $$v)
                              },
                              expression: "form.sport"
                            }
                          })
                        ],
                        1
                      ),
                      !_vm.portsAllowed
                        ? _c(
                            "p",
                            {
                              staticClass: "kvm-help text-caption mt-n2 mb-3"
                            },
                            [_vm._v(" Ports apply to TCP/UDP only. ")]
                          )
                        : _vm._e(),
                      _c("v-text-field", {
                        staticClass: "mb-2",
                        attrs: {
                          label: "Comment",
                          counter: 255,
                          rules: _vm.commentRules,
                          outlined: "",
                          dense: "",
                          "hide-details": "auto"
                        },
                        model: {
                          value: _vm.form.comment,
                          callback: function callback($$v) {
                            _vm.$set(_vm.form, "comment", $$v)
                          },
                          expression: "form.comment"
                        }
                      }),
                      _c("v-checkbox", {
                        staticClass: "mt-1",
                        attrs: {
                          label: "Enabled",
                          dense: "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.form.enable,
                          callback: function callback($$v) {
                            _vm.$set(_vm.form, "enable", $$v)
                          },
                          expression: "form.enable"
                        }
                      }),
                      _vm.ruleDropCausing
                        ? _c("v-checkbox", {
                            staticClass: "mt-1",
                            attrs: {
                              label: "Also reset the VM's existing connections",
                              dense: "",
                              "hide-details": ""
                            },
                            model: {
                              value: _vm.form.immediate,
                              callback: function callback($$v) {
                                _vm.$set(_vm.form, "immediate", $$v)
                              },
                              expression: "form.immediate"
                            }
                          })
                        : _vm._e(),
                      _vm.ruleDropCausing
                        ? _c(
                            "p",
                            {
                              staticClass: "kvm-help text-caption mt-1 mb-0"
                            },
                            [
                              _vm._v(
                                " Blocking rules normally affect new connections only; this also drops already-open ones. "
                              )
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass: "text-right mt-4"
                        },
                        [
                          _c(
                            "gg-btn",
                            {
                              staticClass: "mr-2",
                              attrs: {
                                text: "",
                                disabled: _vm.saving
                              },
                              on: {
                                click: function click($event) {
                                  _vm.ruleDialog = false
                                }
                              }
                            },
                            [_vm._v("Cancel")]
                          ),
                          _c(
                            "gg-btn",
                            {
                              attrs: {
                                tile: "",
                                color: "primary",
                                loading: _vm.saving,
                                disabled: !_vm.formValid
                              },
                              on: {
                                click: _vm.saveRule
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.editing ? "Save changes" : "Add rule"
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "420"
              },
              model: {
                value: _vm.deleteDialog,
                callback: function callback($$v) {
                  _vm.deleteDialog = $$v
                },
                expression: "deleteDialog"
              }
            },
            [
              _c(
                "gg-card",
                [
                  _c(
                    "gg-card-text",
                    {
                      staticClass: "pa-4"
                    },
                    [
                      _c(
                        "h2",
                        {
                          staticClass: "body-1 mb-2 kvm-card-title"
                        },
                        [_vm._v("Delete rule?")]
                      ),
                      _c(
                        "p",
                        {
                          staticClass: "mb-4"
                        },
                        [
                          _vm._v(
                            " This removes the " +
                              _vm._s(
                                _vm.deleteTarget && _vm.deleteTarget.type
                              ) +
                              " rule "
                          ),
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.deleteTarget &&
                                  (_vm.deleteTarget.action || "")
                              )
                            )
                          ]),
                          _vm.deleteTarget && _vm.deleteTarget.comment
                            ? _c("span", [
                                _vm._v(
                                  " (" + _vm._s(_vm.deleteTarget.comment) + ")"
                                )
                              ])
                            : _vm._e(),
                          _vm._v(". ")
                        ]
                      ),
                      _vm.deleteDropCausing
                        ? _c("v-checkbox", {
                            staticClass: "mb-4 mt-0",
                            attrs: {
                              label: "Also reset the VM's existing connections",
                              dense: "",
                              "hide-details": ""
                            },
                            model: {
                              value: _vm.deleteImmediate,
                              callback: function callback($$v) {
                                _vm.deleteImmediate = $$v
                              },
                              expression: "deleteImmediate"
                            }
                          })
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass: "text-right"
                        },
                        [
                          _c(
                            "gg-btn",
                            {
                              staticClass: "mr-2",
                              attrs: {
                                text: "",
                                disabled: _vm.saving
                              },
                              on: {
                                click: function click($event) {
                                  _vm.deleteDialog = false
                                }
                              }
                            },
                            [_vm._v("Cancel")]
                          ),
                          _c(
                            "gg-btn",
                            {
                              attrs: {
                                tile: "",
                                color: "error",
                                loading: _vm.saving
                              },
                              on: {
                                click: _vm.doDelete
                              }
                            },
                            [_vm._v("Delete")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }